import { useEffect, useState } from 'react';

type UseImageReturn = {
  showImage: boolean;
  handleImageError: () => void;
};

/**
 * Hook for handling image loading with fallback support.
 * Tracks whether an image has failed to load and provides a callback for error handling.
 * Resets error state when the image URL changes.
 */
export function useImage(imageUrl: string | null): UseImageReturn {
  const [imageError, setImageError] = useState(false);

  // Reset error state when URL changes so new images get a chance to load
  useEffect(() => {
    setImageError(false);
  }, [imageUrl]);

  const handleImageError = (): void => {
    setImageError(true);
  };

  const showImage = Boolean(imageUrl && !imageError);

  return { showImage, handleImageError };
}
